import React, { useState } from 'react';
import EntrepotList from '../components/entrepot/EntrepotList';
import EntrepotForm from '../components/entrepot/EntrepotForm';
import SingleEntrepot from '../components/entrepot/SingleEntrepot';
import EntrepotDeleteButton from '../components/entrepot/EntrepotDeleteButton';
import EntrepotUpdateForm from '../components/entrepot/EntrepotUpdateForm';

const EntrepotManagementPage = () => {
  const [currentView, setCurrentView] = useState('list');
  const [selectedEntrepotCode, setSelectedEntrepotCode] = useState(null);

  const handleSelectEntrepot = (code_ent) => {
    setSelectedEntrepotCode(code_ent);
    setCurrentView('view');
  };

  return (
    <div>
      {currentView === 'create' && <EntrepotForm />}
      {currentView === 'update' && <EntrepotUpdateForm code_ent={selectedEntrepotCode} />}
      {currentView === 'delete' && <EntrepotDeleteButton code_ent={selectedEntrepotCode} onSuccess={() => setCurrentView('list')} />}
      {currentView === 'list' && (
        <EntrepotList 
          onSelectEntrepot={handleSelectEntrepot}
          onCreateClick={() => setCurrentView('create')}
        />
      )}
      {currentView === 'view' && selectedEntrepotCode && (
        <SingleEntrepot code_ent={selectedEntrepotCode} onChangeView={setCurrentView} />
      )}
    </div>
  );
};

export default EntrepotManagementPage;

